class AccessLogService {
  constructor(serviceBase) {
    this.serviceBase = serviceBase;
  }

  getList(params) {
    return this.serviceBase.getList(params);
  }

  get(accessLogId) {
    return this.serviceBase.get(accessLogId);
  }
}

export default AccessLogService;



// WEBPACK FOOTER //
// ./src/services/AccessLogService.js